import ApiService from "@/core/services/api.service";

export default {
    getChickinAll(credentials) {
        ApiService.setHeader();
        return ApiService.query("v2/verifikasi/nasional/populasi/chickin/all", { params: credentials })
    },
    verifChickin(credentials) {
        ApiService.setHeader();
        return ApiService.put("v2/verifikasi/nasional/populasi/chickin", credentials)
    },

    getDeplesiAll(credentials) {
        ApiService.setHeader();
        return ApiService.query("v2/verifikasi/nasional/populasi/deplesi/all", { params: credentials })
    },
    verifDeplesi(credentials) {
        ApiService.setHeader();
        return ApiService.put("v2/verifikasi/nasional/populasi/deplesi", credentials)
    },

    getFeedInTakeAll(credentials) {
        ApiService.setHeader();
        return ApiService.query("v2/verifikasi/nasional/populasi/feedintake/all", { params: credentials })
    },
    verifFeedInTake(credentials) {
        ApiService.setHeader();
        return ApiService.put("v2/verifikasi/nasional/populasi/feedintake", credentials)
    },

    getTransferAll(credentials) {
        ApiService.setHeader();
        return ApiService.query("v2/verifikasi/nasional/populasi/transfer/all", { params: credentials })
    },
    verifTransfer(credentials) {
        ApiService.setHeader();
        return ApiService.put("v2/verifikasi/nasional/populasi/transfer", credentials)
    },

    getAfkirAll(credentials) {
        ApiService.setHeader();
        return ApiService.query("v2/verifikasi/nasional/populasi/afkir/all", { params: credentials })
    },
    verifAfkir(credentials) {
        ApiService.setHeader();
        return ApiService.put("v2/verifikasi/nasional/populasi/afkir", credentials)
    },

    getProduksiEggAll(credentials) {
        ApiService.setHeader();
        return ApiService.query("v2/verifikasi/nasional/populasi/produksi-egg/all", { params: credentials })
    },
    verifProduksiEgg(credentials) {
        ApiService.setHeader();
        return ApiService.put("v2/verifikasi/nasional/populasi/produksi-egg", credentials)
    },

}